// extracted by mini-css-extract-plugin
module.exports = {"center-el":"RecentFeedbackWidget_center-el_olbGz","widget":"RecentFeedbackWidget_widget_2M2hU"};